module.exports = __webpack_public_path__ + "img/myguard_about_02.35dec00b.png";